import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import type { SessionUser } from '@/hooks/useSession';
import { Reveal } from '../components/Reveal';

export interface FinalCTAProps {
  user: SessionUser | null;
}

export function FinalCTA({ user }: FinalCTAProps) {
  const ctaTo = user ? '/app' : '/sign-up';
  const ctaLabel = user ? 'Open dashboard →' : 'Try it free →';

  return (
    <section className="py-24 lg:py-32">
      <div className="mx-auto max-w-[900px] px-6 text-center lg:px-10">
        <Reveal>
          <h2 className="font-display text-4xl font-semibold tracking-tight md:text-5xl">
            Ready to ship email that{' '}
            <span className="text-primary">actually lands?</span>
          </h2>
        </Reveal>
        <Reveal delay={80}>
          <p className="text-muted-foreground mt-5 text-lg">
            On-brand. Inbox-perfect. Send 50 emails free every month — forever.
          </p>
        </Reveal>
        <Reveal delay={160}>
          <Button size="lg" className="mt-10" asChild>
            <Link to={ctaTo}>{ctaLabel}</Link>
          </Button>
        </Reveal>
        <Reveal delay={220}>
          <div className="mt-5">
            <Link
              to="/docs"
              className="text-muted-foreground hover:text-foreground text-sm transition"
            >
              or browse the API docs →
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
